The type of the signal to be sent.

Currently, only `ApplicationComplete`, `ApplicationStatusUpdate` and `PositionStatusUpdate` are supported.
